import { IDmHe } from "../../../model/response/category/IDmHe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmHeActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IDmHe[],
    LOAD_ERROR: "",
};

export const eDmHeActionIds = generateActionTypeIds(eDmHeActionsObj, "DM_HE");
export type IDmHeActionTypes = IGenericActionType<typeof eDmHeActionsObj, "DM_HE">;
